<template lang="pug">
  div.component-wrapper
    v-tabs(
      color="white"
      slider-color="primary"
      v-model="selectedTab"
    )
      v-tab(to="userApplications" v-if="$store.state.app.destination.id === 1") Applications
      v-tab(to="loginHistory") Connexions
      v-tab(to="mailHistory") Emails envoyés
    router-view.pt-2
</template>

<script>
  export default {
    data() {
      return {
        selectedTab: 0,
      };
    },
    created() {
      if (this.$route.name.includes('ambassador_access')) {
        if (this.$store.state.app.destination.id === 1) {
          this.$router.push('access/userApplications');
        } else {
          this.$router.push('access/loginHistory');
        }
      }
    },
    mounted() {
      this.selectedTab = this.$route.meta.tab;
    },
  };
</script>

<style lang="scss">
  .component-wrapper {
    height: 100%;
    width: 100%;
  }
</style>
